import {Component, inject, Input} from '@angular/core';
import {ModalService} from '@core/services';

export type PlanClosePrecheckAction = 'extend' | 'close' | 'cancel';

@Component({
  selector: 'core-plan-close-precheck',
  imports: [],
  templateUrl: './plan-close-precheck.html',
  styleUrl: './plan-close-precheck.scss',
  standalone: true,
  host: {
    style: 'width: 100%;display:flex;flex-direction:column;gap:0.75rem'
  }
})
export class PlanClosePrecheck {
  @Input() pendingTasks = 0;

  private modal = inject(ModalService);

  choose(action: PlanClosePrecheckAction) {
    this.modal.closeTop<PlanClosePrecheckAction>(action);
  }
}

